import { forwardRef } from "react";
import { FormControl } from "../FormControl";
import { useFormControlProps } from "../hooks";
import type { BaseFormProps } from "../types";
import type { BaseSelectProps } from "./BaseSelect";
import { BaseSelect } from "./BaseSelect";

export type SelectProps = BaseSelectProps & BaseFormProps & { hideError?: boolean };

export const SelectInner = (props: SelectProps, ref: React.ForwardedRef<HTMLSelectElement>) => {
	const { hideError, ...rest } = props;
	const { formControlProps, errorAria, baseProps: selectProps } = useFormControlProps(rest);

	return (
		<FormControl {...formControlProps} hideError={hideError}>
			<BaseSelect
				{...selectProps}
				{...errorAria}
				aria-describedby={hideError ? undefined : errorAria["aria-describedby"]}
				ref={ref}
			/>
		</FormControl>
	);
};

SelectInner.displayName = "Select";

export const Select = forwardRef(SelectInner);
